export const PAGE_DATA_API_ROUTES = {
  GET_PAGE_DATA: "/admin/page-data",
  GET_PAGE_DATA_BY_ID: "admin/page-data/:id",
  CREATE_PAGE_DATA: "/admin/page-data",
  UPDATE_PAGE_DATA: "/admin/page-data/:id",
  DELETE_PAGE_DATA: "/admin/page-data/:id",
};
